// extracted by mini-css-extract-plugin
module.exports = {"container":"_9330de7794--container--sDwIj","side":"_9330de7794--side--m7mv9","rate":"_9330de7794--rate--GMA65","slider-item":"_9330de7794--slider-item--Ub59b"};